import moment from 'moment';

export function upper(value: string) {
  return value.toUpperCase();
}

export function capitalizeFirst (value: string) {
  if (!value) return '';
  const temp = value.toString();
  return temp.charAt(0).toUpperCase() + temp.slice(1);
}

export function removePrefixNumber (value:string) {
  if (!value) return '';
  return !isNaN(+value.slice(0, 3)[0]) ? value.slice(3) : value;
}

export function formatDate (value: string) {
  if (!value) return '';
  return moment(value).format('M/D/YYYY');
}
